import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import { useTodayMeetings } from 'flow/hooks/api/useTodayMeetings';
import TodayMeetingsList from './TodayMeetingsList';

const SkeletonRows = () => (
    <div className="flex flex-col gap-2">
        {[0, 1, 2].map((row) => (
            <div key={row} className="h-12 animate-pulse rounded bg-gray-100" />
        ))}
    </div>
);

const TodayMeetingsSection = () => {
    const { i18next } = useAppContext();
    const { data, isPending, isError } = useTodayMeetings();

    const meetings = data?.meetings ?? [];

    const renderBody = () => {
        if (isPending) {
            return <SkeletonRows />;
        }
        if (isError) {
            return (
                <div className="text-sm text-gray-400">
                    {i18next.t('meetings.today_error')}
                </div>
            );
        }
        if (meetings.length === 0) {
            return (
                <div className="text-sm text-gray-400">
                    {i18next.t('meetings.no_meetings_today')}
                </div>
            );
        }
        return <TodayMeetingsList meetings={meetings} />;
    };

    return (
        <div className="mt-8">
            <p className="mb-3 text-sm font-medium text-gray-600">
                {i18next.t('meetings.today')}
            </p>
            {renderBody()}
        </div>
    );
};

export default TodayMeetingsSection;
